import {Navigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import Auth from '../../auth';

export default function LoginRequired({children}) {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let mounted = true;

    Auth.isLoggedIn().then(isLoggedIn => {
      if (mounted)
        setAllowed(isLoggedIn);
    });

    return () => {
      mounted = false;
    };
  }, []);

  if (allowed === null)
    return null; // or spinner

  if (!allowed)
    return <Navigate to="/login" replace />;

  return children;
}